import {z} from 'zod';

export const bulkAssignMechanicFormSchema = z.object({
  assignMechanicId: z.string(),
});

export type BulkAssignMechanicFormType = z.infer<typeof bulkAssignMechanicFormSchema>;
